import { Component, HostBinding, EventEmitter, HostListener, Output, ElementRef, ViewChild, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

const MAX_FILE_SIZE = 5000000;

@Component({
  selector: 'wsb-ui-dnd-zone',
  templateUrl: './dnd-zone.component.html',
  styleUrls: ['./dnd-zone.component.scss'],
  standalone: false
})
export class DndZoneComponent {
  @ViewChild('inputFileSelection') inputFileSelection: ElementRef;
  @Input() hideFormat = false;
  @Input() hideDownload = false;
  @Input() formatLabel = 'send_sms_recipients_drag_subtitle';
  @Input() fc: UntypedFormControl = new UntypedFormControl();
  @Output() fileDropped = new EventEmitter<any>();

  fileSelected;

  errorMsg;

  @HostBinding('style.background-color') background = '#fff';
  @HostBinding('style.opacity') opacity = '1';

  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#9ecbec';
    this.opacity = '0.8';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#fff';
    this.opacity = '1';
  }

  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#fff';
    this.opacity = '1';
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      if (files[0].size > MAX_FILE_SIZE) {
        return this.fileDropped.emit({ error: true });
      }
      this.errorMsg = null;
      this.fileSelected = files[0];
      this.fileDropped.emit({ file: files });
    }
  }

  constructor() {}

  fileBrowseHandler(files: FileList) {
    if (files) {
      if (files[0].size > MAX_FILE_SIZE) {
        return this.fileDropped.emit({ error: true });
      }
      this.errorMsg = null;
      this.fileSelected = files[0];
      if (files.length > 0) {
        this.fileDropped.emit({ file: files });
      }
    } else {
      this.fileSelected = null;
    }
  }

  openFileSelecion() {
    const e: HTMLElement = this.inputFileSelection.nativeElement;
    e.click();
  }

  resetFileName() {
    this.fileSelected = null;
    this.fc.reset();
  }
}
